import InternalAnchor from './Anchor';
import AnchorLink from './AnchorLink';
var Anchor = InternalAnchor;
Anchor.Link = AnchorLink;
export default Anchor;